import { AlertTriangle, Home, RefreshCcw } from "lucide-react";
import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom";

function getErrorDetails(error: unknown) {
  if (isRouteErrorResponse(error)) {
    return {
      title: `${error.status} ${error.statusText}`,
      message:
        typeof error.data === "string" && error.data.trim().length > 0
          ? error.data
          : "The requested page could not be loaded.",
    };
  }

  if (error instanceof Error) {
    return {
      title: "Something went wrong",
      message: error.message,
    };
  }

  return {
    title: "Something went wrong",
    message: "An unexpected error prevented this page from loading.",
  };
}

export default function RouteError() {
  const error = useRouteError();
  const { title, message } = getErrorDetails(error);

  return (
    <main className="min-h-screen bg-slate-50 px-6 py-16 text-slate-950">
      <section className="mx-auto flex max-w-2xl flex-col items-start gap-6 rounded-lg border border-slate-200 bg-white p-8 shadow-sm">
        <div className="rounded-full bg-red-50 p-3 text-red-600">
          <AlertTriangle aria-hidden="true" className="h-7 w-7" />
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
          <p className="text-sm leading-6 text-slate-600">{message}</p>
        </div>

        <div className="flex flex-wrap gap-3">
          <button
            className="inline-flex items-center gap-2 rounded-md bg-slate-950 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
            type="button"
            onClick={() => window.location.reload()}
          >
            <RefreshCcw aria-hidden="true" className="h-4 w-4" />
            Reload page
          </button>

          <Link
            className="inline-flex items-center gap-2 rounded-md border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100"
            to="/"
          >
            <Home aria-hidden="true" className="h-4 w-4" />
            Return home
          </Link>
        </div>
      </section>
    </main>
  );
}
